import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import '../scss/public.scss';
import Color from '@tool/color';
import { exportExcelFile, locateValue } from '@tool/index';
import {
  ChartIconInActive, ChartIconActive,
  TableIconInActive, TableIconActive, LightIcon,
} from '@styled/icon';
import moFresh, {
  changeType, changeTab,
} from './store';
import Chart from './chart';
import CommonTable from '../../component/common-table';
import CommonTab from '../../component/common-Tab';
import GradeTable from './grade-table';
import TimeTab from '../../component/time-tab';
import CityChoose from './city-choose';
import moIndex, {
  changeFreshCategoryYear, toggleTip,
} from '../../store/index';
import City from './city';
import Empty from '@comp/empty/index';
import moUser from '@store/user';

interface IProps {}
interface IState {}

const DIconButton = styled(IconButton)(() => ({
  width: '32px',
  height: '20px',
  marginRight: '2px',
  borderRadius: '3px',
}));

const ActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.primary,
  '&:hover': { backgroundColor: Color.primary },
}));

const InActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.fff,
  '&:hover': { backgroundColor: Color.fff },
}));

// 涨薪率 - 职能应届生起薪
const CategoryFreshSalary = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    industry, freshCategoryYear, freshCategoryYearList, isMock,
  } = moIndex;
  const { isLogin } = moUser;
  const {
    type, tab, xData, yData, overview, labels,
    cityXData, cityYData, cityOverview, cityLabels,
    yearXData, yearYData, yearOverview, yearLabels,
    tableHead, cityTableHead, yearTableHead,
    tableList, cityTableList, yearTableList,
  } = moFresh;
  const tabList: any[] = [
    { value: '时间趋势', code: 'time' },
    { value: '区分职能', code: 'category' },
    { value: '区分城市', code: 'city' },
  ];

  const exporttable = () => {
    if (moUser.isIndicatorExpired) {
      toggleTip(true);
      return;
    }
    let head:any = [];
    if(tab === 'time'){
      head =[
        ['年份', '大专', '本科','','' , '硕士','','', '博士','',''],
        ['', '不区分','不区分','普通院校','重点院校','不区分','普通院校','重点院校','不区分','普通院校','重点院校'],
      ];
    }else if(tab === 'category'){
      head =[
        ['职能类型', '大专', '本科','','' , '硕士','','', '博士','',''],
        ['', '不区分','不区分','普通院校','重点院校','不区分','普通院校','重点院校','不区分','普通院校','重点院校'],
      ];
    }else{
      head =[
        ['城市', '大专', '本科','','' , '硕士','','', '博士','',''],
        ['', '不区分','不区分','普通院校','重点院校','不区分','普通院校','重点院校','不区分','普通院校','重点院校'],
      ];
    }
    const content :any = [];
    if(tab === 'time'){
      yearTableList.forEach((item:any) => {
        content.push([item.title,...item.arr]);
      });
    }else if(tab === 'category'){
      tableList.forEach((item:any) => {
        content.push([item.title,...item.arr]);
      });
    }else{
      cityTableList.forEach((item:any) => {
        content.push([item.title,...item.arr]);
      });
    }
    const list:any = [...head, ...content];
    const merge = [
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
      { s: { r: 0, c: 2 }, e: { r: 0, c: 4 } },
      { s: { r: 0, c: 5 }, e: { r: 0, c: 7 } },
      { s: { r: 0, c: 8}, e: { r: 0, c: 10 } },
    ];
    exportExcelFile(list, merge, '应届生起薪');
  };


  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="category-fresh-salary_10">
      <section className="one-11 one-1161">
        <section className="one-1191">
          <strong>应届生起薪</strong>
          <span className="tag-02">{industry.name}</span>
          {type === 'chart' ? (
            <ActiveType>
              <ChartIconActive />
            </ActiveType>
          ) : (
            <InActiveType onClick={() => changeType('chart')}>
              <ChartIconInActive />
            </InActiveType>
          )}
          {type === 'table' ? (
            <ActiveType>
              <TableIconActive />
            </ActiveType>
          ) : (
            <InActiveType onClick={() => changeType('table')}>
              <TableIconInActive />
            </InActiveType>
          )}
        </section>
        {tab === 'city' ? <CityChoose /> : null}
      </section>
      <p className="one-1303">
        <span style={{ color: '#878787' }}><LightIcon color={Color.primary} />&nbsp;了解普通院校、重点院校的应届生起薪，请切换至表格查看</span>
      </p>
      <section className="tab-11">
        <CommonTab list={tabList} active={tab} onChange={(val: string) => changeTab(val)} />
      </section>
      {(type === 'chart' && tab === 'category') ? (
        <>
          {!isEmpty(xData) ? (
            <section className="box-11" style={{ marginTop: '20px' }}>
              <section
                className={[
                  "box-13", !isMock ? '' : 'mock-100',
                ].join(' ')}
                style={{ overflowY: 'auto' }}>
                <section className="chart-title_03">
                  {labels.map((item: any, idx: number) => (
                    <p key={idx} className="line-03">
                      <strong>{locateValue(item.value)}</strong>
                      <span style={{ lineHeight: 1.3 }}>{item.text}</span>
                    </p>
                  ))}
                </section>
                <section style={{
                  width: '100%',
                  overflowY: 'auto',
                }}>
                  <Chart height={300} xData={xData} yData={yData} />
                </section>
              </section>
              <section className="box-150">
                <strong>解读：</strong>
                <section className="box-151">
                  {overview.map((text: any, index: number) => (
                    <p key={index}>
                      <span className="ico-11"><b /></span>
                      <i>{text}</i>
                    </p>
                  ))}
                </section>
              </section>
            </section>
          ) : <Empty padding="50px 0" />}
        </>
      ) : null}

      {(type === 'chart' && tab === 'city') ? (
        <>
          {!isEmpty(xData) ? (
            <section className="box-11" style={{ marginTop: '20px' }}>
              <section
                className={[
                  "box-13", !isMock ? '' : 'mock-100',
                ].join(' ')}
                style={{ overflowY: 'auto' }}>
                <section className="chart-title_03">
                  {cityLabels.map((item: any, idx: number) => (
                    <p key={idx} className="line-03">
                      <strong>{locateValue(item.value)}</strong>
                      <span style={{ lineHeight: 1.3 }}>{item.text}</span>
                    </p>
                  ))}
                </section>
                <section style={{
                  width: '100%',
                  overflowY: 'auto',
                }}>
                  <Chart height={300} xData={cityXData} yData={cityYData} />
                </section>
              </section>
              <section className="box-150">
                <strong>解读：</strong>
                <section className="box-151">
                  {cityOverview.map((text: any, index: number) => (
                    <p key={index}>
                      <span className="ico-11"><b /></span>
                      <i>{text}</i>
                    </p>
                  ))}
                </section>
              </section>
            </section>
          ) : <Empty padding="50px 0" />}
        </>
      ) : null}

      {(type === 'chart' && tab === 'time') ? (
        <>
          {!isEmpty(xData) ? (
            <section className="box-11" style={{ marginTop: '20px' }}>
              <section className={[
                "box-13", !isMock ? '' : 'mock-100',
              ].join(' ')}>
                <section className="chart-title_03">
                  {yearLabels.map((item: any, idx: number) => (
                    <p key={idx} className="line-03">
                      <strong>{locateValue(item.value)}</strong>
                      <span style={{ lineHeight: 1.3 }}>{item.text}</span>
                    </p>
                  ))}
                </section>
                <Chart height={300} xData={yearXData} yData={yearYData} />
              </section>
              <section className="box-150">
                <strong>解读：</strong>
                <section className="box-151">
                  {yearOverview.map((text: any, index: number) => (
                    <p key={index}>
                      <span className="ico-11"><b /></span>
                      <i>{text}</i>
                    </p>
                  ))}
                </section>
              </section>
            </section>
          ) : <Empty padding="50px 0" />}
        </>
      ) : null}

      {(type === 'table' && tab === 'category') ? (
        <>
            {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}

          {!isEmpty(tableList) ? (
            <GradeTable tableHead={tableHead} tableArr={tableList} />
          ) : <Empty padding="50px 0" />}
        </>
      ) : null}

      {(type === 'table' && tab === 'city') ? (
        <>
            {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}

          {!isEmpty(tableList) ? (
            <GradeTable tableHead={cityTableHead} tableArr={cityTableList} />
          ) : <Empty padding="50px 0" />}
        </>
      ) : null}

      {(type === 'table' && tab === 'time') ? (
        <>
            {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}

          {!isEmpty(tableList) ? (
            <GradeTable tableHead={yearTableHead} tableArr={yearTableList} />
          ) : <Empty padding="50px 0" />}
        </>
      ) : null}

      {(!isEmpty(xData) && tab !== 'time') ? (
        <TimeTab list={freshCategoryYearList} active={freshCategoryYear}
          onChange={changeFreshCategoryYear} />
      ) : null}
      <City />
    </section>
  );
};

export default observer(CategoryFreshSalary);
